import '../modal/ui-modal-controller.js';
import { UIElement } from '../ui-element.js';
import { Children } from '../../decorators/child.decorator.js';
import { UIToggleTab } from './ui-toggle-tab.js';
import { Component } from '../../decorators/component.decorator.js';
import styles from './ui-toggle-tabbar.css';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIToggleTabbar
 * @element ui-toggle-tabbar
 * @classdesc Represents a class for <code>ui-toggle-tabbar</code> element.
 * It is meant to be used as a wrapper for a group of <code>ui-toggle-tab</code> elements.
 * @property {UiToggleTabbar[]} toggleTabs - {@readonly} Shortcut to toggle tab elements.
 * @example
 * <ui-toggle-tabbar>
 *   <ui-toggle-tab label="Private" name="userProfile" value="private" checked></ui-toggle-tab>
 *   <ui-toggle-tab label="Business" name="userProfile" value="business"></ui-toggle-tab>
 *   <ui-toggle-tab label="VIP" name="userProfile" value="vip"></ui-toggle-tab>
 * </ui-toggle-tabbar>
 */
@Component({
    tag: 'ui-toggle-tabbar',
    styles,
})
export class UIToggleTabbar extends UIElement {
    @Children('ui-toggle-tab')
    toggleTabs!: NodeListOf<UIToggleTab>;

    /**
     * @inheritDoc
     */
    render(): void {
        this.setAttribute('role', 'radiogroup');
    }
}
